import dayjs from 'helpers/dayjs';
import { Dayjs } from 'dayjs';

export default function timeStampToDate(
    timestamp: number
): Dayjs {
    return dayjs(timestamp * 1000);
}
